import { put, takeLatest, all, call, fork } from "redux-saga/effects";
import { fetchData } from "../api";
import { dashboardActions } from "../../constants/actionTypes";
import { statusCode } from "../../constants/apis/apiStatus";
import { toasterFlags } from "../../constants/componentConstants";
import { toastNotification } from "../../utils/toast";
import {
  setData,
  setError,
  resourceProviderListDashboardSuccess,
  resourceProviderListDashboardError,
  resourcesInfoDashboardSuccess,
  resourcesInfoDashboardError,
  setResProviderListLoading,
  setLoadingResourcesDashboard,
  tenantDashboardSuccess,
  tenantDashboardError,
  userDashboardSuccess,
  userDashboardError,
  userDropdownListDashboardSuccess,
  userDropdownListDashboardError,
  setUsersListSearching,
  pendingActionsDashboardSuccess,
  pendingActionsDashboardError,
  setLoadingDashboardTenStats,
  setLoadingDashboardUserStats,
  setPendingActionLoading,
  vmStatsDashboardSuccess,
  vmStatsDashboardError,
  setLoadingDashboardVMStats,
  resetResourceProviderListDashboard,
  billingStatsCurrMonthDashboardSuccess,
  billingStatsLastMonthDashboardSuccess,
  billingStatsDashboardError,
  setLoadingDashboardCurrBillingInfo,
  setLoadingDashboardLastBillingInfo,
  setLoadingDashAllVMs,
  AllVMsDashSuccess,
  AllVMsDashError,
  setLoadingDashTrendingLabs,
  ALLTrendingLabsDashSuccess,
  ALLTrendingLabsDashError,
  UsageTrendsDashboardDailySuccess,
  UsageTrendsDashboardWeeklySuccess,
  usageTrendsDashboardError,
  setLoadingUsageTrends,
  setLoadingUsageHours,
  UsageHoursDashboardSuccess,
  UsageHoursDashboardError,
  setLoadingForecast,
  ForecastDashboardSuccess,
  ForecastDashboardError,
  resouceProviderCountLoading,
  resouceProviderCountError,
  resouceProviderCountSuccess,
} from "../actions/dashboardActions";
import {
  getDashboardResourceProviderListRequest,
  getDashboardResourcesStatsRequest,
  getDashboardTenantStatsRequest,
  getDashboardUserStatsRequest,
  getDashboardUserDropDownRequest,
  getDashboardPendingActionsRequest,
  getDashboardVmStatsRequest,
  getDashboardTenantUserVMStatsRequest,
  getDashboardBillingStatsRequest,
  getDashALLVMList,
  getDashTrendingLabsRequest,
  getDashboardUsageHoursRequest,
  getDashboardForecastBillingRequest,
  getDashboardCSMUsageTrends,
  resourceProviderCountApi,
} from "../api/dashboard";

export function* dummyFunction() {
  try {
    const data = yield call(fetchData);
    const myJSON = Object.values(data)[0];
    yield put(setData(myJSON));
  } catch (err) {
    yield put(setError(err));
  }
}

export function* watchDummy() {
  yield takeLatest(dashboardActions.apiAction, dummyFunction);
}

export function* getDashboardResourceProviderList({ payload }) {
  try {
    yield put(setResProviderListLoading(true));
    const resourceProvidersListDashboard = yield call(getDashboardResourceProviderListRequest, payload?.params);
    if (resourceProvidersListDashboard?.status === statusCode.Ok200) {
      if (payload?.offset === 0 && payload?.searchInProviders) {
        yield put(resetResourceProviderListDashboard());
      }
      yield put(resourceProviderListDashboardSuccess(resourceProvidersListDashboard?.data));
    }
    yield put(setResProviderListLoading(false));
  } catch (err) {
    yield put(resourceProviderListDashboardError(err));
    yield put(setResProviderListLoading(false));
  }
}

export function* getDashboardResourcesStats({ payload }) {
  try {
    yield put(setLoadingResourcesDashboard(true));
    const resourcesStat = yield call(getDashboardResourcesStatsRequest, payload);
    if (resourcesStat?.status === statusCode.Ok200) {
      yield put(resourcesInfoDashboardSuccess(resourcesStat?.data));
    } else {
      yield put(resourcesInfoDashboardError());
      toastNotification(toasterFlags.ERROR, resourcesStat?.data?.message);
    }
    yield put(setLoadingResourcesDashboard(false));
  } catch (err) {
    yield put(resourcesInfoDashboardError(err));
    yield put(setLoadingResourcesDashboard(false));
  }
}
export function* getDashboardTenantStats({ payload }) {
  try {
    yield put(setLoadingDashboardTenStats(true));
    const tenantStats = yield call(getDashboardTenantStatsRequest, payload);
    if (tenantStats?.status === statusCode.Ok200) {
      yield put(tenantDashboardSuccess(tenantStats?.data));
    } else {
      yield put(tenantDashboardError());
      toastNotification(toasterFlags.ERROR, tenantStats?.data?.message);
    }
    yield put(setLoadingDashboardTenStats(false));
  } catch (err) {
    yield put(tenantDashboardError(err));
    yield put(setLoadingDashboardTenStats(false));
  }
}

export function* getDashboardUserStats({ payload }) {
  try {
    yield put(setLoadingDashboardUserStats(true));
    const userStats = yield call(getDashboardUserStatsRequest, payload);
    if (userStats?.status === statusCode.Ok200) {
      yield put(userDashboardSuccess(userStats?.data));
    } else {
      yield put(userDashboardError());
      toastNotification(toasterFlags.ERROR, userStats?.data?.message);
    }
    yield put(setLoadingDashboardUserStats(false));
  } catch (err) {
    yield put(userDashboardError(err));
    yield put(setLoadingDashboardUserStats(false));
  }
}

export function* getDashboardUserDropDownList({ payload }) {
  try {
    yield put(setUsersListSearching(true));
    const userStats = yield call(getDashboardUserDropDownRequest, payload?.params);
    if (userStats?.status === statusCode.Ok200) {
      if (payload?.offset === 0 && payload?.searchInuser) {
        yield put(userDropdownListDashboardError(""));
        yield put(userDropdownListDashboardSuccess(userStats?.data));
      } else {
        yield put(userDropdownListDashboardSuccess(userStats?.data));
      }
    } else {
      toastNotification(toasterFlags.ERROR, userStats?.data?.message);
    }
    yield put(setUsersListSearching(false));
  } catch (err) {
    yield put(userDropdownListDashboardError(err));
    yield put(setUsersListSearching(false));
  }
}
export function* getDashboardPendingActionsCount() {
  try {
    yield put(setPendingActionLoading(true));
    const count = yield call(getDashboardPendingActionsRequest);
    if (count?.status === statusCode.Ok200) {
      yield put(pendingActionsDashboardSuccess(count?.data?.["pending-action"]));
    } else {
      toastNotification(toasterFlags.ERROR, count?.data?.message);
      yield put(pendingActionsDashboardError(""));
    }
    yield put(setPendingActionLoading(false));
  } catch (err) {
    yield put(pendingActionsDashboardError(err));
    yield put(setPendingActionLoading(false));
  }
}
export function* getDashboardVMStats({ payload }) {
  try {
    yield put(setLoadingDashboardVMStats(true));
    const vmStats = yield call(getDashboardVmStatsRequest, payload);
    if (vmStats?.status === statusCode.Ok200) {
      yield put(vmStatsDashboardSuccess(vmStats?.data));
    } else {
      yield put(vmStatsDashboardError());
      toastNotification(toasterFlags.ERROR, vmStats?.data?.message);
    }
    yield put(setLoadingDashboardVMStats(false));
  } catch (err) {
    yield put(vmStatsDashboardError(err));
    yield put(setLoadingDashboardVMStats(false));
  }
}
export function* getDashboardVMTenantUserStats() {
  try {
    yield put(setLoadingDashboardVMStats(true));
    const vmStats = yield call(getDashboardTenantUserVMStatsRequest);
    if (vmStats?.status === statusCode.Ok200) {
      yield put(vmStatsDashboardSuccess(vmStats?.data));
    } else {
      yield put(vmStatsDashboardError());
      toastNotification(toasterFlags.ERROR, vmStats?.data?.message);
    }
    yield put(setLoadingDashboardVMStats(false));
  } catch (err) {
    yield put(vmStatsDashboardError(err));
    yield put(setLoadingDashboardVMStats(false));
  }
}

export function* getDashBillingStats({ payload }) {
  try {
    if (payload?.reqFor === "last_month") {
      // yield put(setLoadingDashboardLastBillingInfo(true));
    } else {
      // yield put(setLoadingDashboardCurrBillingInfo(true));
    }
    const billStats = yield call(getDashboardBillingStatsRequest, { urlParams: payload?.params, reqBody: payload?.reqBody });
    if (billStats?.status === statusCode.Ok200 || billStats?.status === statusCode.Created201) {
      if (payload?.reqFor === "last_month") {
        yield put(billingStatsLastMonthDashboardSuccess(billStats?.data));
      } else {
        yield put(billingStatsCurrMonthDashboardSuccess(billStats?.data));
      }
    } else {
      yield put(billingStatsDashboardError(payload?.reqFor));
      //toastNotification(toasterFlags.ERROR, billStats?.data?.message);
    }
    if (payload?.reqFor === "last_month") {
      yield put(setLoadingDashboardLastBillingInfo(false));
    } else {
      yield put(setLoadingDashboardCurrBillingInfo(false));
    }
  } catch (err) {
    yield put(billingStatsDashboardError(payload?.reqFor));
    if (payload?.reqFor === "last_month") {
      yield put(setLoadingDashboardLastBillingInfo(false));
    } else {
      yield put(setLoadingDashboardCurrBillingInfo(false));
    }
  }
}
export function* getDashboardVMsListAndDetails({ payload }) {
  try {
    yield put(setLoadingDashAllVMs(true));
    const allVMs = yield call(getDashALLVMList, payload);
    if (allVMs?.status === statusCode.Ok200) {
      yield put(AllVMsDashSuccess(allVMs?.data));
    } else {
      yield put(AllVMsDashError());
      toastNotification(toasterFlags.ERROR, allVMs?.data?.message);
    }
    yield put(setLoadingDashAllVMs(false));
  } catch (err) {
    yield put(AllVMsDashError(err));
    yield put(setLoadingDashAllVMs(false));
  }
}

export function* getDashboardTrendingLabs({ payload }) {
  try {
    yield put(setLoadingDashTrendingLabs(true));
    const trendingLabs = yield call(getDashTrendingLabsRequest, payload);
    if (trendingLabs?.status === statusCode.Ok200) {
      yield put(ALLTrendingLabsDashSuccess(trendingLabs?.data));
    } else {
      yield put(ALLTrendingLabsDashError());
      toastNotification(toasterFlags.ERROR, trendingLabs?.data?.message);
    }
    yield put(setLoadingDashTrendingLabs(false));
  } catch (err) {
    yield put(ALLTrendingLabsDashError(err));
    yield put(setLoadingDashTrendingLabs(false));
  }
}
export function* getDashboardUsageTrends({ payload }) {
  try {
    yield put(setLoadingUsageTrends(true));
    const trendingLabs = yield call(getDashboardCSMUsageTrends, { urlParams: payload?.params, reqBody: payload?.reqBody });
    if (trendingLabs?.status === statusCode.Ok200) {
      if (payload?.reqFor === "daily") {
        yield put(UsageTrendsDashboardDailySuccess(trendingLabs?.data));
      } else {
        yield put(UsageTrendsDashboardWeeklySuccess(trendingLabs?.data));
      }
    } else {
      yield put(usageTrendsDashboardError(payload?.reqFor));
      //toastNotification(toasterFlags.ERROR, trendingLabs?.data?.message);
    }
    yield put(setLoadingUsageTrends(false));
  } catch (err) {
    yield put(usageTrendsDashboardError(payload?.reqFor));
    yield put(setLoadingUsageTrends(false));
  }
}

export function* getDashboardUsageHours({ payload }) {
  try {
    yield put(setLoadingUsageHours(true));
    const usageHours = yield call(getDashboardUsageHoursRequest, { urlParams: payload });
    if (usageHours?.status === statusCode.Ok200) {
      yield put(UsageHoursDashboardSuccess(usageHours?.data));
    } else {
      yield put(UsageHoursDashboardError(payload?.reqFor));
    }
    yield put(setLoadingUsageHours(false));
  } catch (err) {
    yield put(UsageHoursDashboardError(payload?.reqFor));
    yield put(setLoadingUsageHours(false));
  }
}

export function* getDashboardBillingForecast({ payload }) {
  try {
    // yield put(setLoadingForecast(true));
    const forecast = yield call(getDashboardForecastBillingRequest, { urlParams: payload });
    if (forecast?.status === statusCode.Ok200) {
      yield put(ForecastDashboardSuccess(forecast?.data));
    } else {
      yield put(ForecastDashboardError(forecast?.data));
    }
    yield put(setLoadingForecast(false));
  } catch (err) {
    yield put(setLoadingForecast(false));
  }
}

export function* resourceProviderCountSaga({ payload }) {
  try {
    yield put(resouceProviderCountLoading(true));
    const response = yield call(resourceProviderCountApi, payload);
    if (response?.status === statusCode.Ok200) {
      yield put(resouceProviderCountSuccess(response?.data));
    } else {
      yield put(resouceProviderCountError(payload?.reqFor));
    }
    yield put(resouceProviderCountLoading(false));
  } catch (err) {
    yield put(resouceProviderCountError(payload?.reqFor));
    yield put(resouceProviderCountLoading(false));
  }
}

export function* dashboardSaga() {
  yield takeLatest(dashboardActions.getResourceProviderDashboard, getDashboardResourceProviderList);
  yield takeLatest(dashboardActions.getResourcesInfoDashboard, getDashboardResourcesStats);
  yield takeLatest(dashboardActions.getTenantsStatsDashboard, getDashboardTenantStats);
  yield takeLatest(dashboardActions.getUserStatsDashboard, getDashboardUserStats);
  yield takeLatest(dashboardActions.getUserDropDownDashboard, getDashboardUserDropDownList);
  yield takeLatest(dashboardActions.getPendingActions, getDashboardPendingActionsCount);
  yield takeLatest(dashboardActions.getVMStats, getDashboardVMStats);
  yield takeLatest(dashboardActions.getVMStatsTenantUserDashboard, getDashboardVMTenantUserStats);
  yield takeLatest(dashboardActions.getBillingStatsDashboardCurrMonth, getDashBillingStats);
  yield takeLatest(dashboardActions.getBillingStatsDashboardLastMonth, getDashBillingStats);
  yield takeLatest(dashboardActions.getAllVMs, getDashboardVMsListAndDetails);
  yield takeLatest(dashboardActions.getAllTrendingLabs, getDashboardTrendingLabs);
  yield takeLatest(dashboardActions.getDashboardUsageDailyTrends, getDashboardUsageTrends);
  yield takeLatest(dashboardActions.getDashboardUsageWeeklyTrends, getDashboardUsageTrends);
  yield takeLatest(dashboardActions.getDashboardUsageHours, getDashboardUsageHours);
  yield takeLatest(dashboardActions.getDashboardForecast, getDashboardBillingForecast);
  yield takeLatest(dashboardActions.RESOURSE_PROVIDER_COUNT_ACTION, resourceProviderCountSaga);
}
export default function* rootSaga() {
  yield all([fork(dashboardSaga)]);
}
